// 导入组件
import Vue from "vue";
import Router from "vue-router";
// 登录
import Login from "@/views/Login";
// 首页布局
import Index from "@/views/Index";
// 首页欢迎页面
import Hello from "@/views/Hello"


/* 
  用户权限管理 
*/
// 角色管理
import AdminRoleManager from "@/views/AdminManager/AdminRoleManager";
// 用户管理
import AdminUserManager from "@/views/AdminManager/AdminUserManager";

/* 
  应用基础配置 
*/
// 应用配置
import AppConfig from "@/views/DataConfig/AppConfig";
// 渠道配置
import ChannelConfig from "@/views/DataConfig/ChannelConfig";

/* 
  数据显示配置 
*/
// 数据类型配置
import DataTypeConfig from "@/views/ShowConfig/DataTypeConfig";
// 数据显示配置
import AdminDataSumShowConfig from "@/views/ShowConfig/AdminDataSumShowConfig";
//数据方案配置
import AdminDataSumShowGroupConfig from "@/views/ShowConfig/AdminDataSumShowGroupConfig";


/* 
  总计数据更新管理 
*/

// 总计数据更新管理
import UserTaskData from "@/views/UpdateTask/UserTaskData";
// 游戏统计数据更新管理
import UserGameTaskData from "@/views/UpdateTask/UserGameTaskData";


/* 
  渠道用户管理 
*/

// 渠道用户业务员分成管理
import ChannelPriceUser from "@/views/ChannelUser/ChannelPriceUser";

/* 
  统计数据 
*/
// 总计统计数据
import DataSum from "@/views/Data/DataSum";
// 游戏统计数据
import DataGame from "@/views/Data/DataGame";


// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  routes: [
    {
      path: "/Login",
      name: "登录",
      component: Login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: "/Login",
      name: "登录",
      component: Login,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },
    {
      path: "/Index",
      name: "首页",
      component: Index,
      children: [
        {
          path: "/AdminRoleManager",
          name: "角色管理",
          component: AdminRoleManager,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/AdminUserManager",
          name: "用户管理",
          component: AdminUserManager,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/DataTypeConfig",
          name: "数据类型配置",
          component: DataTypeConfig,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/AdminDataSumShowConfig",
          name: "数据显示配置",
          component: AdminDataSumShowConfig,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/AdminDataSumShowGroupConfig",
          name: "数据方案配置",
          component: AdminDataSumShowGroupConfig,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/DataSum",
          name: "总计统计数据",
          component: DataSum,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/UserTaskData",
          name: "数据更新管理",
          component: UserTaskData,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/AppConfig",
          name: "应用配置",
          component: AppConfig,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/ChannelConfig",
          name: "渠道配置",
          component: ChannelConfig,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/ChannelPriceUser",
          name: "业务员管理",
          component: ChannelPriceUser,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/UserGameTaskData",
          name: "游戏统计数据更新管理",
          component: UserGameTaskData,
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/DataGame",
          name: "游戏统计数据",
          component: DataGame,
          meta: {
            requireAuth: true
          }
        }   
                                 
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js